import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bea0e45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right-block-wrapper d-flex align-items-center" }
const _hoisted_2 = { class: "carousel" }
const _hoisted_3 = { class: "carousel__item" }
const _hoisted_4 = { class: "carousel-subtitle-wrapper d-flex align-items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "description" }

import { ref } from "vue";
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';


export default /*#__PURE__*/_defineComponent({
  __name: 'RightSideBlock',
  setup(__props) {

const slidesData = ref([
  {
    title: "Collaborate smartly",
    description: [
      {
        titleDescription: "Journey Builder",
        textDescription: "Customises and anchors every sales process and activity",
        icon: "checkbox.png"
      },
      {
        titleDescription: "Data-Room & Form Builder",
        textDescription: "Assembles all data, forms and templates",
        icon: "checkbox.png"
      },
      {
        titleDescription: "Project Board",
        textDescription: "Provides full visibility over every aspect of client projects",
        icon: "checkbox.png"
      },
      {
        titleDescription: "Platform Extensibility",
        textDescription: "Integrates with existing data, solutions and processes",
        icon: "checkbox.png"
      },
    ]
  },
  {
    title: "Sell successfully with smace",
    description: [
      {
        titleDescription: "Work seamlessly together",
        textDescription: "Keep everyone on the same page with improved visibility of the sales process",
        icon: "benefit1.png"
      },
      {
        titleDescription: "Streamline and optimize",
        textDescription: "Streamline your sales process, remove confusion and frustration and optimize for success",
        icon: "benefit2.png"
      },
      {
        titleDescription: "Maximize your sales",
        textDescription: "Get the most out of your sales process by using the right tools and process to achieve your goals",
        icon: "benefit3.png"
      },
    ]
  }
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("template", _hoisted_2, [
      _createVNode(_unref(Carousel), {
        autoplay: 5000,
        "wrap-around": true,
        "pause-autoplay-on-hover": ""
      }, {
        addons: _withCtx(() => [
          _createVNode(_unref(Pagination))
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slidesData.value, (slide, index) => {
            return (_openBlock(), _createBlock(_unref(Slide), { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h2", null, _toDisplayString(slide.title), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide.description, (description, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "pros-wrapper"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                          src: require(`@/assets/icons/${description.icon}`),
                          alt: "icon"
                        }, null, 8, _hoisted_5),
                        _createElementVNode("h3", _hoisted_6, _toDisplayString(description.titleDescription), 1)
                      ]),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(description.textDescription), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})